<!-- 管理员 tab栏 -->
<template>
  <div class="tabs clearfix" :style="{ borderBottom: 'solid 2px #166779' }">
    <div
      v-for="item in tabs"
      :key="item.code"
    >
      <div
        v-show="item.bool==='1'"
        class="tabslist"
        :class="active===item.code?'active':''"
        @click="handleClick(item.code)"
        v-text="$t(item.text)"
      />
    </div>

    <div v-if="stationRoute" class="right" style="font-size:18px;line-height:40px;color:#fff">
      <span>{{ $t('text.dqzd') }}：<a style="color:#fff ">{{ stationName }}</a></span>
      <el-button style="margin:0 30px;font-size:18px;color:#fff" icon="el-icon-d-arrow-left" type="text" @click="backToHome">{{ $t('button.fh') }}</el-button>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      tabs: [],
      list: {
        list: [
          { text: 'text.lbzd', code: 'list', bool: '1' },
          { text: 'text.tpzd', code: 'image', bool: '1' },
        ],
        myinfo: [
          { text: 'text.grxx', code: 'info', bool: '1' },
          { text: 'sider.logo', code: 'logo', bool: '1' }
        ],
        series: [
          { text: 'text.zcnbq', code: 'series', bool: this.$store.getters.gtypes.iscluster },
          { text: 'text.db', code: 'meter', bool: this.$store.getters.gtypes.ismeter },
          { text: 'text.qx', code: 'weather', bool: this.$store.getters.gtypes.isweather },
          { text: 'text.cnnbq', code: 'energy', bool: this.$store.getters.gtypes.isstore },
        ],
        meter_billsettings: [
          { text: 'text.dfdttsz', code: 'head', bool: '1' },
          { text: 'text.dfdsz1', code: 'setbill', bool: '1' },
          { text: 'text.czsl', code: 'pic', bool: '1' }
        ],
        home: [
          { text: 'sider.xtgk', code: 'home', bool: '1' },
        ],
        devicerecharge: [
          { text: 'sider.deviceRecharge', code: 'devicerecharge', bool: '1' },
        ],
        compare: [
          { text: 'sider.xtbj', code: 'compare', bool: '1' },
        ],
        alarm: [
          { text: 'sider.bjzx', code: 'alarm', bool: '1' },
        ],
        import: [
          { text: 'sider.sbdr', code: 'import', bool: '1' },
        ],
        auth: [
          { text: 'sider.sbsq', code: 'auth', bool: '1' },
        ],
        manager: [
          { text: 'sider.yhgl', code: 'manager', bool: '1' },
        ],
        changepwd: [
          { text: 'sider.xgmm', code: 'changepwd', bool: '1' },
        ],
        camera: [
          { text: '视频监控', code: 'camera', bool: '1' },
        ],
        timeshare: [
          { text: 'sider.fscx', code: 'timeshare', bool: '1' },
        ],
        offlinenotify: [
          { text: 'sider.offlineNotify', code: 'offlinenotify', bool: '1' },
        ],
        add: [
          { text: 'sider.xzdd', code: 'add', bool: '1' },
        ]
      },
      active: '',
      stationRoute: false,
      stationName: '',
    }
  },
  computed: {
    /**
     * 登录账号是否是金象华升账号
     */
    isJinXiangHuaShengUser: function () {
      return this.$store.getters.id === process.env.VUE_APP_JinXiangHuaSheng_Userid
    }
  },
  watch: {
    $route (val) {
      this.showtab(val)
    },
  },
  mounted () {
    this.showtab()
  },
  methods: {
    showtab (val) {
      this.tabs = []
      const routeMeta = val ? val.meta : this.$route.meta
      const routeName = routeMeta.name
      if (routeMeta && routeMeta.showTab && routeName.indexOf('mulshow') === -1) {
        this.tabs = this.list[routeName]
        this.active = this.list[routeName][0].code
      } else if (routeName && routeName.includes('mulshow') && routeMeta.showTab && this.$store.getters.station.orgtype === '0') {
        this.tabs = this.list.series
        if (this.$route.meta.name.indexOf('series') !== -1) {
          this.active = 'series'
        } else if (this.$route.meta.name.indexOf('meter') !== -1) {
          this.active = 'meter'
        } else if (val.meta.name.indexOf('energy') !== -1) {
          this.active = 'energy'
        } else if (val.meta.name.indexOf('weather') !== -1) {
          this.active = 'weather'
        } else if (val.meta.name.indexOf('switch_controls') !== -1) {
          this.active = 'switch_controls'
        }
      }
      // 显示电站名称判断
      this.stationRoute = routeName.includes('energy') || routeName.includes('meter') || routeName.includes('series') || routeName.includes('weather') || routeName.includes('switch')
      this.stationName = this.$store.getters.station.orgname
    },
    handleClick (code) {
      this.active = code
      this.$bus.$emit(code)
    },
    // 回到系统列表
    backToHome () {
      this.$router.replace('/list')
    },
  }
}
</script>
<style scoped>
.tabslist::before {
  content: '';
  position: absolute;
  background: #fff;
  border-radius: 50%;
  width: 5px;
  height: 5px;
  left: 5px;
  top: 13px;
}
.tabs {
  background-color: #1c2550;
  position: relative;
  left: 200px;
  width: calc(100% - 200px);
  height: 40px;
  box-sizing: border-box;
}
.tabs .tabslist {
  float: left;
  text-align: center;
  line-height: 40px;
  color: #fff;
  cursor: pointer;
  position: relative;
  padding: 0 15px;
  margin: 0 0px 0 3px;
  height: 30px;
  top: 4px;
  line-height: 30px;
}
.tabs .tabslist.active {
  color: #fff;
  font-weight: bolder;
  background: #1a4a6e;
}

</style>
